import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

/**
 * Fetches a single user's activity logs on a project for one day (YYYY-MM-DD).
 * The backend enforces the activity_log_view permission and looks up the project's
 * business_id. Returns the API payload (`{ items }`).
 */
export const getActivityLogsForUserProjectDate = async ({
  projectId,
  userId,
  date,
  activeEmployerInfo = {},
  isLocalApiRequest = false,
}) => {
  const apiPath = `activity-log/project/${projectId}/user/${userId}/${date}`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
    isLocalApiRequest,
  });

  const response = await axios(signedRequest);

  return response.data;
};
